export const caseStudiesData = {
  navItems: [
    { label: "支援事例について", anchor: "#about-cases" },
    { label: "会員管理", anchor: "#case-01" },
    { label: "予約システム", anchor: "#case-02" },
    { label: "AIナレッジ検索", anchor: "#case-03" },
    { label: "支援の共通点", anchor: "#approach" },
    { label: "お問い合わせ", anchor: "#contact" },
  ],

  hero: {
    breadcrumbs: [
      { label: "ホーム", href: "/" },
      { label: "支援事例", href: null },
    ],
    label: "CASE STUDIES",
    mainCopy: "課題を整理し、\n現場で使える仕組みへ",
    description:
      "企業や団体が抱えていた業務上の課題と、ノーブルラボが行った支援をご紹介します。ツールやシステムを導入することだけでなく、その後も無理なく運用できる状態を整えています。",
    tags: [
      { label: "中小企業・地域団体", icon: "ri-building-2-line" },
      { label: "業務整理から対応", icon: "ri-file-list-3-line" },
      { label: "導入後の運用も支援", icon: "ri-settings-3-line" },
      { label: "実際の支援事例", icon: "ri-check-double-line" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20background%20with%20soft%20cream%20and%20pale%20beige%20layers%2C%20delicate%20flowing%20shapes%20suggesting%20data%20tables%20form%20fields%20folders%20and%20business%20process%20flowcharts%2C%20subtle%20grid%20patterns%20and%20geometric%20forms%20fading%20into%20the%20composition%2C%20warm%20orange%20amber%20accents%2C%20no%20people%20no%20faces%2C%20editorial%20abstract%20suitable%20for%20hero%20section%2C%20calm%20professional%20atmosphere%20with%20warm%20light%20tones%2C%20organic%20paper%20texture%20background&width=1920&height=1080&seq=case-studies-hero-bg&orientation=landscape",
  },

  about: {
    label: "ABOUT CASE STUDIES",
    title: "仕組みだけでなく、支援前後の業務の変化をご紹介します",
    description:
      "ノーブルラボでは、最初から特定のツールやシステムを提案するのではなく、現在の業務と困りごとを確認することから始めます。",
    description2:
      "既存サービスで解決できる場合は導入や移行を支援し、既存の仕組みだけでは解決できない場合は、必要な業務ツールを設計・開発します。",
    description3:
      "このページでは、実際に行った支援を、相談前の状態、実施内容、導入後の変化、現在の運用に分けてご紹介します。",
    flowSteps: [
      { label: "現状を確認する", icon: "ri-search-eye-line" },
      { label: "課題を整理する", icon: "ri-file-list-3-line" },
      { label: "方法を選ぶ", icon: "ri-arrow-left-right-line" },
      { label: "導入・開発する", icon: "ri-tools-line" },
      { label: "運用を支える", icon: "ri-settings-3-line" },
    ],
  },

  caseList: {
    label: "CASE LIST",
    title: "ノーブルラボの支援事例",
    cases: [
      {
        id: "01",
        orgType: "学校同窓会組織・会員団体",
        title: "約2,000件の会員データをクラウドへ移行",
        summary:
          "ローカル環境で管理されていた会員情報を整理し、クラウド型の会員管理システムへ移行。事務局が継続して更新できる環境を整えました。",
        relatedServices: ["AI・デジタル導入支援", "伴走型AI事務局サポート"],
        anchor: "#case-01",
        image:
          "https://readdy.ai/api/search-image?query=Abstract%20diagram%20showing%20local%20database%20migration%20to%20cloud%20database%2C%20clean%20minimal%20design%20with%20two%20boxes%20connected%20by%20arrow%2C%20one%20labeled%20local%20DB%20with%20folder%20icon%20the%20other%20labeled%20cloud%20DB%20with%20cloud%20icon%2C%20data%20tables%20and%20records%20flowing%20between%2C%20warm%20cream%20background%20with%20soft%20orange%20accents%2C%20no%20people%2C%20corporate%20abstract%20illustration%20style&width=800&height=500&seq=case-01-diagram&orientation=landscape",
      },
      {
        id: "02",
        orgType: "地域団体",
        title: "アナログ対応の貸会議室予約をオンライン化",
        summary:
          "電話で受け付けていた貸会議室の予約を、空き状況の公開、オンライン申込、自動返信に対応した仕組みへ移行しました。",
        relatedServices: ["業務ツール・システム開発", "伴走型AI事務局サポート"],
        anchor: "#case-02",
        image:
          "https://readdy.ai/api/search-image?query=Abstract%20comparison%20diagram%20showing%20phone%20and%20notebook%20on%20left%20side%20transitioning%20to%20online%20reservation%20form%20with%20calendar%20on%20right%20side%2C%20minimal%20clean%20illustration%20style%2C%20arrow%20showing%20transformation%2C%20warm%20cream%20background%20with%20soft%20orange%20accents%2C%20no%20people%2C%20corporate%20abstract%20flat%20design&width=800&height=500&seq=case-02-diagram&orientation=landscape",
      },
      {
        id: "03",
        orgType: "学術団体",
        title: "論文やコラムをAIで横断検索できる仕組み",
        summary:
          "PDFやHTMLで蓄積された論文・コラムを検索対象とし、自然な質問から回答と参考文献を確認できるナレッジデータベースを構築しました。",
        relatedServices: ["業務ツール・システム開発", "AI・デジタル導入支援"],
        anchor: "#case-03",
        image:
          "https://readdy.ai/api/search-image?query=Abstract%20diagram%20showing%20PDF%20and%20HTML%20documents%20on%20left%20side%20connecting%20to%20an%20AI%20search%20interface%20on%20right%20side%2C%20knowledge%20database%20concept%2C%20natural%20language%20question%20flowing%20into%20search%20results%20with%20reference%20links%2C%20minimal%20clean%20illustration%2C%20warm%20cream%20background%20with%20soft%20orange%20accents%2C%20no%20people%2C%20corporate%20abstract%20flat%20design&width=800&height=500&seq=case-03-diagram&orientation=landscape",
      },
    ],
  },

  case01: {
    label: "CASE 01",
    subLabel: "MEMBERSHIP MANAGEMENT",
    title: "約2,000件の会員データをクラウドへ移行",
    orgName: "立教経済人クラブ",
    orgType: "学校校友会組織・会員団体",
    orgNameAnonymous: "都内の学校同窓会組織",
    isAnonymous: false,

    beforeTitle: "相談前の状態",
    beforeDescription:
      "当団体では、会員情報を、前任者が構築したローカルのデータベースで管理していました。長年にわたり複数の担当者が更新してきたため、表記や入力方法が統一されておらず、データの整理と移行に大きな負担がありました。また、特定の端末や担当者に管理が依存しており、今後も継続して情報を更新していくためには、管理環境の見直しが必要な状態でした。",

    challenges: [
      "会員データがローカル環境に保存されている",
      "約2,000件のデータに表記や入力方法のばらつきがある",
      "複数の担当者が長年にわたり更新している",
      "特定の端末や担当者に管理が依存している",
      "会員情報以外の履歴も一元的に管理したい",
      "移行後も事務局が自分たちで更新できる必要がある",
    ],

    supportTitle: "データを整理しながら、クラウド型の会員管理システムへ移行",
    supportDescription:
      "既存データの内容や項目を確認し、クラウド上で継続して管理できる環境への移行を支援しました。会員管理システムには、イーストゲート社の「SmartCore」を採用しています。データをそのまま移すのではなく、表記や項目の違いを確認しながら整理し、移行後の管理方法も事務局と確認しました。",
    supportItems: [
      "既存データの確認",
      "管理項目の整理",
      "表記や入力内容の確認",
      "SmartCoreへのデータ移行",
      "会員情報の管理環境整備",
      "入金履歴の管理",
      "セミナー参加履歴の管理",
      "事務局への操作支援",
      "運用開始後の相談対応",
    ],

    afterTitle: "支援後の変化",
    afterDescription:
      "現在は、会員の個人情報、入金履歴、セミナー参加履歴などをクラウド上で管理しています。特定の端末に依存せず、事務局が必要な情報を確認・更新できるようになりました。日常的な登録や変更は事務局が行い、操作方法や運用に迷った場合は、Noble Laboがサポートしています。",
    afterStats: [
      { label: "総データ数", value: "約2,000件" },
      { label: "管理対象", value: "会員情報" },
      { label: "管理対象", value: "入金履歴" },
      { label: "管理対象", value: "セミナー参加履歴" },
      { label: "更新担当", value: "事務局" },
      { label: "運用支援", value: "Noble Labo" },
    ],

    flowImage:
      "https://readdy.ai/api/search-image?query=Abstract%20horizontal%20process%20flow%20diagram%20showing%20five%20connected%20steps%20with%20arrows%2C%20first%20box%20shows%20local%20database%20icon%2C%20second%20box%20shows%20data%20review%20and%20cleanup%2C%20third%20box%20shows%20cloud%20migration%20to%20SmartCore%2C%20fourth%20box%20shows%20cloud%20operation%20by%20staff%2C%20fifth%20box%20shows%20Noble%20Labo%20support%2C%20minimal%20clean%20flat%20design%2C%20warm%20cream%20background%20with%20orange%20accent%20arrows%2C%20no%20people%2C%20corporate%20abstract%20illustration&width=1000&height=400&seq=case-01-flow&orientation=landscape",
  },

  case02: {
    label: "CASE 02",
    subLabel: "ROOM RESERVATION",
    title: "アナログ対応の貸会議室予約をオンライン化",
    orgType: "地域団体",

    beforeTitle: "相談前の状態",
    beforeDescription:
      "地域団体が運営する貸会議室では、利用者から電話で予約を受け付け、事務局がノートへ記録して管理していました。利用者は、電話をするまで現在の空き状況を確認できませんでした。事務局にも、空室確認や予約受付に関する電話が集中し、予約内容を手作業で管理する負担が発生していました。",

    challenges: [
      "利用者が空き状況を確認できない",
      "電話による空室確認が多い",
      "予約受付が事務局の対応時間に限られる",
      "電話の内容をノートへ記録している",
      "予約内容の確認に手間がかかる",
      "キャンセルや変更を事務局が個別に管理している",
    ],

    supportTitle: "予約状況の公開から、申込・通知までをオンライン化",
    supportDescription:
      "ウェブ上で貸会議室の空き状況を確認し、そのまま予約を申し込める仕組みを導入しました。予約は即時確定ではなく、事務局が内容を確認して承認する方式としています。利用者が申込みを送信すると、お問い合わせIDを記載した自動返信メールが届きます。キャンセルが発生した場合も事務局へメールで通知され、予約状況へ反映されます。",
    supportItems: [
      "空き状況の公開",
      "オンライン予約申込",
      "事務局承認",
      "自動返信メール",
      "お問い合わせIDの発行",
      "事務局への予約通知",
      "キャンセル通知",
      "予約状況の更新",
    ],

    afterTitle: "支援後の変化",
    afterDescription: "",
    afterStats: [
      { label: "月間利用件数", value: "約30件" },
      { label: "予約方式", value: "事務局承認制" },
      { label: "受付方法", value: "オンライン" },
      { label: "自動返信", value: "あり" },
      { label: "電話対応", value: "事務局の実感では約半減" },
    ],

    beforeFlow: {
      title: "導入前",
      steps: [
        "空き状況を電話で確認",
        "事務局が電話対応",
        "ノートへ記入",
        "変更・キャンセルも個別管理",
      ],
    },
    afterFlow: {
      title: "導入後",
      steps: [
        "ウェブで空き状況を確認",
        "オンラインで申込み",
        "自動返信・受付ID発行",
        "事務局が確認・承認",
        "予約状況をオンラインで管理",
      ],
    },
  },

  case03: {
    label: "CASE 03",
    subLabel: "AI KNOWLEDGE DATABASE",
    title: "論文をAIによって検索するシステムの構築",
    orgType: "学術団体",

    beforeTitle: "相談前の状態",
    beforeDescription:
      "学術団体のウェブサイトには、長年にわたり多数の論文やコラムが蓄積されていました。資料はPDFとHTMLの両方で公開され、掲載場所や分類も分かれていたため、利用者が必要な情報を探すことが難しい状態でした。論文名や適切な検索キーワードを把握していない場合、目的の資料へたどり着くまでに複数のページを確認する必要がありました。",

    challenges: [
      "論文やコラムが複数の場所に掲載されている",
      "PDFとHTMLが混在している",
      "キーワード検索だけでは必要な資料を探しにくい",
      "利用者が論文名や専門用語を知らないことがある",
      "新しい論文やコラムが継続的に追加される",
      "回答の根拠となる資料を確認できる必要がある",
    ],

    supportTitle: "自然な質問から、関連する論文と回答へたどり着ける仕組みを構築",
    supportDescription:
      "公開されているPDFやHTMLの論文・コラムを検索対象として登録し、利用者がAIエージェントへ質問できるナレッジデータベースを構築しました。AIは、検索対象として登録された資料をもとに回答を生成します。回答画面には、根拠となった論文やコラムを参考文献として表示し、利用者が元の資料を確認できるようにしています。",
    supportItems: [
      "PDF・HTMLの横断検索",
      "自然な文章による質問",
      "検索対象資料をもとにした回答生成",
      "参考文献の表示",
      "元資料への導線",
      "一般公開",
      "新規コンテンツの定期的な自動取得",
      "検索データの自動更新",
    ],

    afterTitle: "支援後の変化",
    afterDescription:
      "利用者は、論文名や正確なキーワードを知らない場合でも、知りたい内容を自然な文章で質問できるようになりました。AIが質問に関連する情報を検索し、回答とともに根拠となった参考文献を表示します。これにより、検索結果を一つずつ確認するだけでなく、質問を入口として関連する論文やコラムへたどり着けるようになりました。また、新しく公開された論文やコラムは、定期的に動作するプログラムによって検索対象へ追加されます。",
    afterStats: [
      { label: "対象形式", value: "PDF・HTML" },
      { label: "利用方法", value: "自然文による質問" },
      { label: "回答方法", value: "検索対象資料をもとに生成" },
      { label: "根拠表示", value: "参考文献を表示" },
      { label: "公開範囲", value: "一般公開" },
      { label: "更新方法", value: "定期プログラムによる自動更新" },
    ],

    flowImage:
      "https://readdy.ai/api/search-image?query=Abstract%20process%20diagram%20showing%20knowledge%20database%20workflow%2C%20starting%20with%20PDF%20and%20HTML%20documents%20icons%2C%20arrow%20to%20scheduled%20program%20icon%20for%20collection%20and%20update%2C%20arrow%20to%20knowledge%20database%20icon%2C%20arrow%20to%20user%20asking%20natural%20language%20question%2C%20arrow%20to%20AI%20search%20icon%2C%20arrow%20to%20answer%20with%20references%20display%2C%20minimal%20clean%20flat%20design%2C%20warm%20cream%20background%20with%20orange%20accent%20arrows%2C%20no%20people%2C%20corporate%20abstract%20illustration&width=1000&height=450&seq=case-03-flow&orientation=landscape",
  },

  approach: {
    label: "OUR APPROACH",
    title: "ツールの導入だけでなく、使い続けられる状態に",
    items: [
      {
        num: "01",
        title: "現在の業務を確認する",
        desc: "表面的な依頼だけでなく、誰がどのように業務を行っているかを確認します。",
      },
      {
        num: "02",
        title: "適切な方法を選ぶ",
        desc: "既存サービスの導入、データ移行、独自開発など、課題に合う方法を選びます。",
      },
      {
        num: "03",
        title: "実際の運用に合わせる",
        desc: "担当者、権限、確認手順、更新方法まで含めて仕組みを整えます。",
      },
      {
        num: "04",
        title: "導入後も相談できる",
        desc: "操作や運用に迷った場合の相談、保守、改善にも対応します。",
      },
    ],
    bottomText:
      "つくることや導入することではなく、現場で使われ続けることを重視しています。",
  },

  relatedServices: {
    label: "RELATED SERVICES",
    title: "課題に応じて、必要な支援をご提案",
    items: [
      {
        title: "DX顧問",
        desc: "会社全体の業務課題を整理し、改善を継続して支援します。",
        href: "/service/dx-consultant",
        icon: "ri-user-star-line",
      },
      {
        title: "伴走型AI事務局サポート",
        desc: "団体や会員組織の事務局運営を、年間を通じて支援します。",
        href: "/service/ai-office",
        icon: "ri-team-line",
      },
      {
        title: "AI・デジタル導入支援",
        desc: "既存のAIやクラウドサービスの選定、設定、移行、研修を支援します。",
        href: "/service/ai-digital",
        icon: "ri-robot-line",
      },
      {
        title: "業務ツール・システム開発",
        desc: "既存ツールだけでは解決できない業務に必要な仕組みを開発します。",
        href: "/service/business-tool",
        icon: "ri-code-s-slash-line",
      },
    ],
  },

  cta: {
    label: "CONTACT",
    heading: "自社・自団体の課題も、一緒に考えませんか",
    description:
      "具体的なツールやシステムが決まっていなくても問題ありません。現在の業務と困りごとを伺い、既存サービスの活用、導入支援、独自開発など、適切な方法を整理します。",
    beforeFormPoints: [
      "課題が整理されていない段階でも相談可能",
      "既存ツールと独自開発を比較",
      "データ移行・業務整理にも対応",
      "導入後の運用・保守も相談可能",
    ],
    inquiryTypes: [
      "支援事例について",
      "業務ツール・システム開発について",
      "DX顧問について",
      "伴走型AI事務局サポートについて",
      "AI・デジタル導入について",
      "その他",
    ],
  },
};